import { render, staticRenderFns } from "./Testing.vue?vue&type=template&id=32a81194&scoped=true&"
import script from "./Testing.vue?vue&type=script&lang=js&"
export * from "./Testing.vue?vue&type=script&lang=js&"
import style0 from "./Testing.vue?vue&type=style&index=0&id=32a81194&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a81194",
  null
  
)

export default component.exports